import { AppBar, Box, Button, Divider, IconButton, Toolbar, Typography } from "@mui/material"
import React from "react"
import AddCardIcon from '@mui/icons-material/AddCard';
import HeaderDispatch from "./model";
import { Hstate } from "../../State/HeaderState";
import PaymentDialog from "../../SubComponent/UI/PaymentDialog";
import { payment } from "../../../../../../config/api";
import MenuIcon from '@mui/icons-material/Menu';

class Header extends React.Component<{}>{
    render() {

        let dispatcher: HeaderDispatch = (this.props as any).dispatcher
        let state: Hstate = (this.props as any).state

        return (
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="fixed">
                    <Toolbar>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            onClick={() => {
                                dispatcher.profile()
                            }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="subtitle2" component="div" sx={{ mr: 2 }}>
                         فایل چرخ
                        </Typography>
                     
                        <Box sx={{ flexGrow: 1 }} />

                        <Button variant="contained" startIcon={<AddCardIcon sx={{ ml: 1 }} />} color="secondary" size='small' onClick={() => {
                            dispatcher.payment(true)
                        }}>
                            شارژ کیف پول
                        </Button>
                    </Toolbar>
                </AppBar>

                <PaymentDialog isOpen={state.header.paymentDialogIsOpen} onPayClicked={(amount) => {
                    dispatcher.payment(false)
                    window.location.href = payment.replace(":phone", state.user?.phone ?? '').replace(':amount', amount.toString())

                }} onClose={() => {
                    dispatcher.payment(false)
                }} />
            </Box>
        )
    }
}

export default Header